import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { API_URL, apiMethod, apiType } from 'utils';
import { GET_AFE_FLEET_ITEM_CANCEL, GET_ASSET_FLEET_ITEM_CANCEL, GET_FLEET_ITEM_CANCEL } from '../../Store/FleetManagement/FleetItemCancel/FleetItemCancelType'
import { setAssetFleetItemCancel, setFleetItemCancel } from 'Store/FleetManagement/FleetItemCancel/FleetItemCancelAction';
import { IPayload } from 'Model/IPayload';

function* FleetItemCancelSaga(req: any): any {
    try {
        yield put(globalLoaderText("Cancelling Fleet Item...."));
        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `requisition/fleet/item/cancel`,
            apiMethod :  apiMethod.PUT,
            payload : req?.fleetItemId
        }
        const response = yield call(
            FleetManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );
        if (response) {
            yield put(setFleetItemCancel({...response, fleetId: req?.fleetItemId?.fleetDetailId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* AssetFleetItemCancelSaga(req: any): any {
    try {
        yield put(globalLoaderText("Cancelling Asset Fleet Item...."));

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `asset/fleet/item/cancel`,
            apiMethod :  apiMethod.PUT,
            payload : req?.AssetfleetItemId
        }
        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData        
        );
        if (response) {
            yield put(setAssetFleetItemCancel({response: response, fleetItemId: req?.AssetfleetItemId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* AfeFleetItemCancelSaga(req: any): any {
    try {
        yield put(globalLoaderText("Cancelling AFE Fleet Item...."));

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `afe/fleet/item/cancel`,
            apiMethod :  apiMethod.PUT,
            payload : req?.afeFleetItemId
        }
        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setAssetFleetItemCancel({response: response, fleetItemId: req?.afeFleetItemId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetItemCancel() {
    yield takeEvery(GET_FLEET_ITEM_CANCEL, FleetItemCancelSaga)
    yield takeEvery(GET_ASSET_FLEET_ITEM_CANCEL, AssetFleetItemCancelSaga)
    yield takeEvery(GET_AFE_FLEET_ITEM_CANCEL, AfeFleetItemCancelSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetItemCancel()
    ])
}
